import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import VuexReset from '@ianwalter/vuex-reset'
import createCache from 'vuex-cache'

import registration from './modules/registration.store'
import commonEntities from './modules/common-entities.store'
import auth from './modules/auth.store'
import billing from './modules/billing.store'
import campaign from './modules/campaign.store'
import dashboard from './modules/dashboard.store'
import account from './modules/account.store'
import country from './modules/country.store'
import sellerOffer from './modules/sellerOffer.store'
import callLogs from './modules/call-logs.store'
import creative from './modules/creative.store'
import globalSettings from './modules/global-settings.store'
import onboarding from './modules/onboarding.store'
import verificationChecklist from './modules/verification-checklist.store'
import ringbaTokens from './modules/ringba-tokens.store'
import ringbaAccounts from './modules/ringba-accounts.store'
import ringTreeTargetRequest from './modules/ring-tree-target-request.store'
import insights from './modules/insights.store'

import test from './modules/test.store'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

const state = {
  isSidebarExpanded: true,

  isDashboardNotificationVisible: false,

  dashboardNotificationMessageDetails: {
    text: '',
    linkText: '',
    routeName: '',
    hideOnClick: true
  }
}

const actions = {
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },

  showDashboardNotification({ commit }, messageDetails) {
    commit('SET_DASHBOARD_NOTIFICATION_VISIBILITY', { show: true, messageDetails })
  },

  hideDashboardNotification({ commit }) {
    commit('SET_DASHBOARD_NOTIFICATION_VISIBILITY', { show: false, messageDetails: '' })
  }
}

const mutations = {
  TOGGLE_SIDEBAR(state) {
    state.isSidebarExpanded = !state.isSidebarExpanded
  },

  SET_DASHBOARD_NOTIFICATION_VISIBILITY(state, { show, messageDetails }) {
    state.isDashboardNotificationVisible = show
    state.dashboardNotificationMessageDetails = messageDetails
  },

  reset() {
    return {}
  }
}


const getters = {}

export default new Vuex.Store({
  modules: {
    registration,
    'common-entities': commonEntities,
    auth,
    billing,
    campaign,
    test,
    dashboard,
    account,
    country,
    sellerOffer,
    callLogs,
    creative,
    globalSettings,
    onboarding,
    'verification-checklist': verificationChecklist,
    ringbaTokens,
    ringbaAccounts,
    ringTreeTargetRequest,
    insights
  },
  strict: debug,
  plugins: debug ? [createLogger(), VuexReset(), createCache({
    timeout: 3000
  })] : [VuexReset(), createCache({
    timeout: 3000
  })],
  state,
  mutations,
  actions,
  getters
})
